export const pageRecruit = {
    loadDone: function (results) {
        $(".js-ajax").html(results["template"]);
        $(".js-content").hide().fadeIn(300);

        pageRecruit.bindControls();

        $(".js-submit").unbind();
        $(".js-submit").click(function () {
            const btn = this;
            form.disableButtons(btn);
            pageRecruit.clearErrors();

            $(".nursery__side-menu-content").data("editing", "false");
            window.removeEventListener("beforeunload", nursery.saveAlert);

            const url = $("#basicForm").attr("action");
            const paramList = new FormData(document.getElementById("basicForm"));

            post.postAjaxData(
                url,
                paramList,
                "更新が完了しました",
                function () {
                    form.activateButtons(btn);
                },
                function (jqXHR) {
                    pageRecruit.showFieldErrors(jqXHR);
                    form.activateButtons(btn);
                },
                null
            );
        });

        $("form").change(function () {
            $(".nursery__side-menu-content").data("editing", "true");
            window.addEventListener("beforeunload", nursery.saveAlert);
        });
    },

    clearErrors: function () {
        $(".error__message").remove();
        $(".error").removeClass("error");
    },

    showFieldErrors: function (jqXHR) {
        if (!jqXHR.responseJSON || !jqXHR.responseJSON.errors) {
            return;
        }
        const errors = jqXHR.responseJSON.errors;

        for (const key in errors) {
            const parts = key.split(".");
            let nameAttr = parts[0];
            for (let i = 1; i < parts.length; i++) {
                nameAttr += `[${parts[i]}]`;
            }
            const $field = $(`[name="${nameAttr}"]`);
            if ($field.length > 0) {
                const $wrapper = $field.closest(
                    ".form__input--textarea, .form__input--text, .form__input--text-half, .form__input--select"
                );
                if ($wrapper.length > 0) {
                    $wrapper.addClass("error");
                    const message = Array.isArray(errors[key]) ? errors[key][0] : errors[key];
                    // 表示位置を取得する。専用プレースホルダがあればそこに、なければ入力欄の直後に表示する
                    const $placeholder = $(`[data-error-for="${nameAttr}"]`);
                    if ($placeholder.length > 0) {
                        $placeholder.append(`<span class="error__message" role="alert">${message}</span>`);
                    } else {
                        $wrapper.after(`<span class="error__message" role="alert">${message}</span>`);
                    }
                }
            }
        }
    },

    bindControls: function () {
        if ($("#js-interviews-fieldset").length) {
            pageRecruit.bindInterviewControls();
        }
        if ($("#js-stats-fieldset").length) {
            pageRecruit.bindStatsControls();
        }
    },

    bindStatsControls: function () {
        $("form").on("change", ".js-stats-select", function () {
            const item = $(this).closest(".js-stats-item");
            const selected = $(this).find("option:selected");
            const label = selected.val();
            const unit = selected.data("unit") || "";
            const description = selected.data("description") || "";

            item.find(".js-stats-label").val(label);
            item.find(".js-stats-value")
                .attr("placeholder", selected.data("placeholder") || "例：1")
                .val("");
            // 平均値の項目は範囲入力できないため、最大の入力欄を無効化し範囲入力の説明も隠す
            const allowsRange = String(selected.data("allows-range")) === "1";
            item.find(".js-stats-value-max")
                .val("")
                .prop("disabled", label !== "" && !allowsRange);
            item.find(".js-stats-range-description").toggle(label === "" || allowsRange);

            const preview = item.find(".js-stats-preview");
            if (label) {
                preview.show();
                preview.find(".js-stats-preview-value").text("—");
                preview.find(".js-stats-preview-unit").text(unit);
                preview.find(".js-stats-preview-label").text(label);
                preview.find(".js-stats-preview-desc").text(description);
            } else {
                preview.hide();
            }
        });

        $("form").on("input", ".js-stats-value, .js-stats-value-max", function () {
            const item = $(this).closest(".js-stats-item");
            const value = item.find(".js-stats-value").val();
            const valueMax = item.find(".js-stats-value-max").val();
            // 「0」もfalsyにせず値として扱うため、空文字かどうかで明示的に判定する
            const display = value !== "" && valueMax !== "" ? `${value}～${valueMax}` : value;
            item.find(".js-stats-preview-value").text(display !== "" ? display : "—");
        });

        $("#js-stats-fieldset").on("click", ".js-add-stats", function () {
            const container = $("#js-stats-container");
            const idx = container.find(".js-stats-item").length;
            if (idx >= 4) {
                return;
            }
            const paramList = new FormData();
            paramList.append("index", idx);
            post.postAjaxData(
                "/nursery/recruit/stats/item",
                paramList,
                "",
                function (results) {
                    container.append(results["template"]);
                    pageRecruit.toggleStatsAddButton();
                },
                null,
                null
            );
        });

        $("#js-stats-fieldset").on("click", ".js-remove-stats", function () {
            $(this).closest(".js-stats-item").remove();
            pageRecruit.reindexStats();
            pageRecruit.toggleStatsAddButton();
        });

        pageRecruit.toggleStatsAddButton();
    },

    // 数をチェックして追加ボタンの有無。
    toggleStatsAddButton: function () {
        if ($("#js-stats-container .js-stats-item").length >= 4) {
            $("#js-stats-add-area").hide();
        } else {
            $("#js-stats-add-area").show();
        }
    },

    bindInterviewControls: function () {
        $("#js-interviews-fieldset").on("click", ".js-add-interview", function () {
            const container = $("#js-interviews-container");
            const idx = container.find(".js-interview-item").length;
            const paramList = new FormData();
            paramList.append("index", idx);
            post.postAjaxData(
                "/nursery/recruit/interviews/item",
                paramList,
                "",
                function (results) {
                    container.append(results["template"]);
                },
                null,
                null
            );
        });

        $("#js-interviews-fieldset").on("click", ".js-remove-interview", function () {
            $(this).closest(".js-interview-item").remove();
            pageRecruit.reindexInterviews();
        });

        $("#js-interviews-fieldset").on("click", ".js-add-qa", function () {
            const qaContainer = $(this).closest(".form__qa-container");
            const iIdx = qaContainer.data("interview-index");
            const qIdx = qaContainer.find(".js-qa-item").length;
            const paramList = new FormData();
            paramList.append("interviewIndex", iIdx);
            paramList.append("qaIndex", qIdx);
            post.postAjaxData(
                "/nursery/recruit/interviews/qa-item",
                paramList,
                "",
                function (results) {
                    qaContainer.find(".js-add-qa").before(results["template"]);
                },
                null,
                null
            );
        });

        $("#js-interviews-fieldset").on("click", ".js-remove-qa", function () {
            const qaContainer = $(this).closest(".form__qa-container");
            $(this).closest(".js-qa-item").remove();
            const iIdx = qaContainer.data("interview-index");
            pageRecruit.reindexQas(qaContainer, iIdx);
        });

        $("#js-interviews-fieldset").on("change", ".js-question-select", function () {
            const val = $(this).val();
            const hiddenInput = $(this).closest(".js-qa-item").find(".js-question-hidden");
            hiddenInput.val(val);
        });
    },

    reindexInterviews: function () {
        $("#js-interviews-container .js-interview-item").each(function (idx) {
            $(this).attr("data-index", idx);
            $(this)
                .find(".form__repeater-label")
                .first()
                .text(`スタッフ ${idx + 1}`);
            $(this)
                .find("[name]")
                .each(function () {
                    const name = $(this)
                        .attr("name")
                        .replace(/interviews\[\d+\]/, `interviews[${idx}]`);
                    $(this).attr("name", name);
                });
            pageRecruit.reindexAttr($(this), "id", /interviews-\d+/, `interviews-${idx}`);
            pageRecruit.reindexAttr($(this), "for", /interviews-\d+/, `interviews-${idx}`);
            const qaContainer = $(this).find(".form__qa-container");
            qaContainer.attr("data-interview-index", idx);
            pageRecruit.reindexQas(qaContainer, idx);
        });
    },

    reindexQas: function (qaContainer, iIdx) {
        qaContainer.find(".js-qa-item").each(function (qIdx) {
            $(this)
                .find(".form__qa-label")
                .text(`Q&A ${qIdx + 1}`);
            $(this)
                .find("[name]")
                .each(function () {
                    const name = $(this)
                        .attr("name")
                        .replace(/interviews\[\d+\]/, `interviews[${iIdx}]`)
                        .replace(/\[qa\]\[\d+\]/, `[qa][${qIdx}]`);
                    $(this).attr("name", name);
                });
            pageRecruit.reindexAttr($(this), "id", /interviews-\d+-qa-\d+/, `interviews-${iIdx}-qa-${qIdx}`);
            pageRecruit.reindexAttr($(this), "for", /interviews-\d+-qa-\d+/, `interviews-${iIdx}-qa-${qIdx}`);
        });
    },

    reindexStats: function () {
        $("#js-stats-container .js-stats-item").each(function (idx) {
            $(this).attr("data-index", idx);
            $(this)
                .find(".form__repeater-label")
                .first()
                .text(`数字 ${idx + 1}`);
            $(this).find(".js-stats-select").attr("data-index", idx);
            $(this)
                .find("[name]")
                .each(function () {
                    const name = $(this)
                        .attr("name")
                        .replace(/stats\[\d+\]/, `stats[${idx}]`);
                    $(this).attr("name", name);
                });
            pageRecruit.reindexAttr($(this), "data-error-for", /stats\[\d+\]/, `stats[${idx}]`);
            pageRecruit.reindexAttr($(this), "id", /stats-\d+/, `stats-${idx}`);
            pageRecruit.reindexAttr($(this), "for", /stats-\d+/, `stats-${idx}`);
            pageRecruit.reindexAttr($(this), "aria-describedby", /stats-\d+/g, `stats-${idx}`);
        });
    },

    // ラベルと入力欄の紐付け(id/for)を並び替え後のインデックスに振り直す
    reindexAttr: function ($item, attrName, pattern, replacement) {
        $item.find(`[${attrName}]`).each(function () {
            const value = $(this).attr(attrName);
            $(this).attr(attrName, value.replace(pattern, replacement));
        });
    }
};
